export class RootObject {
  extension: Extension[];
  search: string;
  count: number;
  duration: number;
}

export class Extension {
  feature?: Feature[];
  label: string;
  display: string;
}

export class Feature {
  extensionName: string;
  display: string;
  extent: string;
  geometry: string;
  Text?: any;
  layer: string;
  featureType: string;
}

export class MapNote {
  public id: number;
  public name: string;
  public remarks: string;
  public latitude: number;
  public longitude: number;
}
